import axios from "axios";
const jsonConfig = require("../../Config.json");



const recentInvitations = async (payload) => {
  try {
    const getAllResponse = await axios.post(
      jsonConfig.apiUrl + "recentInvitations", payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default recentInvitations;